import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title @model.name}}\n\n{{outlet}}")